/**
 * Telefonie-iconen — Heroicons outline stijl, 24x24 viewBox, stroke 1.5.
 * Zelfde idioom als layout/sidebar-icons.tsx, maar met className-prop zodat
 * ze inline in tekst en in knoppen van verschillende maten passen.
 */

interface IconProps {
  className?: string;
}

const HANDSET_PATH =
  'M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z';

export function PhoneIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={HANDSET_PATH} />
    </svg>
  );
}

/** Hoorn met pijl naar binnen (linksonder) — inkomend gesprek. */
export function PhoneInboundIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d={`M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6 ${HANDSET_PATH}`}
      />
    </svg>
  );
}

/** Hoorn met pijl naar buiten (rechtsboven) — uitgaand gesprek. */
export function PhoneOutboundIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d={`M20.25 3.75v4.5m0-4.5h-4.5m4.5 0l-6 6 ${HANDSET_PATH}`}
      />
    </svg>
  );
}

/** Verbodsteken — blacklist. */
export function NoSymbolIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <circle cx={12} cy={12} r={9} strokeWidth={1.5} />
      <path strokeLinecap="round" strokeWidth={1.5} d="M5.64 5.64l12.72 12.72" />
    </svg>
  );
}
